module.exports = __webpack_public_path__ + "static/media/Arica.6f5c67a0.png";